<script lang="ts" setup>
import { ref } from 'vue'

const props = withDefaults(defineProps<{
  value: boolean
  chapterId?: string | number
  chapterNo?: number
}>(), {
  value: false,
})

const emit = defineEmits<{
  (event: 'input', value: boolean): void
  (event: 'confirm', chapterId: string | number | undefined, resetAppearance: boolean): void
}>()

const resetAppearance = ref(true)

function onConfirm() {
  emit('confirm', props.chapterId, resetAppearance.value)
  emit('input', false)
}

function onCancel() {
  emit('input', false)
}
</script>

<template>
  <transition name="confirm-fade">
    <div
      v-if="value"
      class="fixed inset-0 z-50 flex items-center justify-center"
      style="background-color: rgba(0, 0, 0, 0.8);"
      @click.self="onCancel"
    >
      <div
        style="position: relative; width: 315px; border-radius: 10px; overflow: hidden; background-color: rgba(255, 255, 255, 1);"
      >
        <!-- 渐变标题头 -->
        <div
          class="confirm-header"
          style="position: absolute; left: 0; top: 0; right: 0; height: 44px; display: flex; align-items: center; justify-content: center;"
        >
          <span style="color: rgba(255, 255, 255, 1); font-size: 16px; font-family: Inter-Medium; font-weight: 500; line-height: 12px;">Restart</span>
        </div>
        <!-- 内容区 -->
        <div style="padding: 58px 20px 20px 20px;">
          <p style="color: rgba(50, 53, 58, 1); font-size: 16px; font-family: Inter-Medium; font-weight: 500; line-height: 22px; width: 275px;">
            {{ chapterId === undefined ? 'Would you like to restart this book?' : `Restart ${chapterNo}. The current reading chapter progress will not be retained, and all paid content will be retained.` }}
          </p>
          <!-- Reset appearance 复选框 -->
          <div class="reset-row" @click="resetAppearance = !resetAppearance">
            <div class="reset-checkbox" :class="{ checked: resetAppearance }">
              <svg v-if="resetAppearance" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 3L3 5L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <span class="reset-label">Reset appearance</span>
          </div>
          <!-- 按钮行 -->
          <div class="btn-row">
            <button class="btn-no" @click="onCancel">
              No
            </button>
            <button class="btn-yes" @click="onConfirm">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.25s ease;
}
.confirm-fade-enter,
.confirm-fade-leave-to {
  opacity: 0;
}
.confirm-header {
  background: linear-gradient(270deg, rgba(255, 107, 210, 1) 0%, rgba(161, 98, 255, 1) 100%);
}
.reset-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  cursor: pointer;
  width: fit-content;
  user-select: none;
}
.reset-checkbox {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.reset-checkbox.checked {
  background: linear-gradient(225deg, rgba(248, 107, 205, 1) 0%, rgba(156, 94, 249, 1) 100%);
}
.reset-checkbox:not(.checked) {
  background-color: rgba(216, 216, 216, 1);
  border: 1px solid rgba(151, 151, 151, 1);
}
.reset-label {
  color: rgba(106, 110, 122, 1);
  font-size: 14px;
  font-family: Inter-Regular;
  font-weight: normal;
  line-height: 14px;
}
.btn-row {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.btn-no {
  width: 120px;
  height: 36px;
  border: 1px solid rgba(187, 122, 251, 1);
  border-radius: 18px;
  color: rgba(187, 122, 251, 1);
  font-size: 14px;
  font-family: Inter-Medium;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
}
.btn-no:active {
  opacity: 0.7;
}
.btn-yes {
  width: 120px;
  height: 36px;
  border: none;
  border-radius: 18px;
  background: linear-gradient(225deg, rgba(248, 107, 205, 1) 0%, rgba(156, 94, 249, 1) 100%);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: Inter-Medium;
  font-weight: 500;
  cursor: pointer;
}
.btn-yes:active {
  opacity: 0.7;
}
</style>
